import {Injectable} from '@angular/core';
import {take} from 'rxjs/operators';
import {IAppliedFiltersUpdater} from '../../../shared/advanced-filters/applied-filters-updater';
import {AdvanceFilterParamType, IAdvanceFilter} from '../../../shared/advanced-filters/components/advance-filter';
import {DocumentListingFacade} from '../store/document-listing.facade';

@Injectable({
  providedIn: 'root'
})
export class DocumentsAppliedFiltersUpdaterService implements IAppliedFiltersUpdater<AdvanceFilterParamType>{

  constructor(private documentListingFacade:DocumentListingFacade) { }

    filterClose(filter: Partial<IAdvanceFilter<AdvanceFilterParamType>>): void {
        this.documentListingFacade.onFilterClose(filter);
    }

    update(filter: IAdvanceFilter<AdvanceFilterParamType>): void {
      this.documentListingFacade.updateAdvancedFilter(filter);
      this.documentListingFacade.appliedAdvancedFilters$
          .pipe(take(1))
          .subscribe(filters =>{
             if (filters.length > 0 && filters.every(y=>y.isApplied)) {
                 this.documentListingFacade.fetchDocuments();
             }
          });
    }
}
